<template>
  <div class="mobile-header">
    <div class="logo-main">
      <van-image
        class="logo-img"
        :src="require('@/assets/logo.png')"
        @click="backHome"
      />
    </div>
    <div class="search-main">
      <div class="keyword-main" @mouseleave="clearList">
        <van-field
          v-model="keyword"
          @input="changeInput"
          @click="clickInput"
          clearable
          class="keyword-input"
          placeholder="请输入您要搜索的资源名称"
        />
        <div class="keyword-content">
          <div class="keyword-list" v-if="keyword !== '' && list.length > 0">
            <div
              v-for="(item, index) in list"
              :key="index"
              class="keyword-li"
              @click="clickKeyword($event.target.innerText)"
              v-html="item"
            ></div>
          </div>
        </div>
      </div>

      <van-button type="info" @click="onSearch" class="keyword-search"
        >搜索</van-button
      >
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      keyword: this.$store.getters.keyword,
      list: [],
    };
  },
  watch: {
    $route: function () {
      this.keyword = this.$store.getters.keyword;
    },
  },
  methods: {
    // 点击搜索
    onSearch() {
      this.$store.dispatch("setKeyword", this.keyword);
      if (this.$route.name !== "search-list") {
        this.$router.push({
          path: "/",
          query: { t: Math.random() },
        });
      }
    },
    backHome() {
      window.location = "https://kjpd.kepuchina.cn/";
    },
    clickKeyword(name) {
      this.keyword = name;
      this.onSearch();
      this.clearList();
    },
    clickInput() {
      if (this.keyword !== "") {
        this.changeInput(this.keyword);
      }
    },
    async changeInput(value) {
      try {
        const { data } = await this.$axios.post(`Articleeducate/getTitle`, {
          title: value,
        });
        this.list = data;
      } catch (error) {
        this.error = true;
        this.errorText = error?.errorMSg ?? "暂无数据";
      }
    },
    clearList() {
      this.$store.dispatch("setKeyword", this.keyword);
      this.list = [];
    },
  },
};
</script>
<style lang="scss" scoped>
.logo-main {
  text-align: center;
  border-bottom: 1px solid #f3f7ff;

  .logo-img {
    width: 237px;
    height: 60px;
    margin-top: 20px;
    margin-bottom: 20px;
    cursor: pointer;
  }
}

.search-main {
  position: relative;
  margin-top: 20px;
  text-align: center;
}

.keyword-main {
  position: relative;
  display: inline-block;
  width: 530px;
  margin-left: 0;
  vertical-align: top;

  .keyword-input {
    width: 530px;
    height: 68px;
    padding: 10px 16px;
    font-size: 28px;
    border: 1px solid #0047ff;
    border-radius: 4px;
  }

  .keyword-content {
    position: absolute;
    top: 75px;
    left: 0;
    z-index: 100;
  }

  .keyword-list {
    width: 490px;
    height: auto;
    padding: 20px;
    margin-top: 10px;
    text-align: left;
    background: white;
    border: 1px solid #0047ff;
    border-radius: 4px;

    .keyword-li {
      width: 100%;
      overflow: hidden;
      font-size: 28px;
      font-weight: 400;
      line-height: 55px;
      text-overflow: ellipsis;
      white-space: nowrap;
      cursor: pointer;

      ::v-deep span {
        color: rgb(0 71 255 / 100%);
      }
    }
  }
}

.keyword-search {
  display: inline-block;
  width: 127px;
  height: 68px;
  margin-top: 0;
  margin-left: 10px;
  vertical-align: top;
  background: #0047ff;
  border-radius: 4px;
}
</style>
